import { render } from "./workshopUser.vue?vue&type=template&id=7b9bd5da&scoped=true"
import script from "./workshopUser.vue?vue&type=script&lang=js"
export * from "./workshopUser.vue?vue&type=script&lang=js"

import "./workshopUser.vue?vue&type=style&index=0&id=7b9bd5da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9bd5da"]])

export default __exports__